import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { HttpErrorResponse } from "@angular/common/http";
import { catchError, debounceTime, switchMap, withLatestFrom } from "rxjs/operators";
import { EMPTY, of } from "rxjs";
import { OrganizationDetailsService } from "@services/organization-details.service";
import { Store } from "@ngrx/store";
import { OrganizationEMRDetailsActions } from "@store/actions/organization-emr-details/organization-emr-details.actions";
import { selectOrgId } from "@store/selectors/organization-emr-details/organization-emr-details.selector";
import { parseProblemDetailsError } from "../../../utils/api-error.util";

@Injectable()
export class OrganizationEMRDetailsEffects {

  // Auto-save ACO status when the radio changes. Uses its own endpoint (separate from
  // /update/EMR) since ACO membership lives on the Organization, not on any one EHR record.
  saveACOOnChange$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(OrganizationEMRDetailsActions.isACOChanged),
      debounceTime(300),
      withLatestFrom(this.store.select(selectOrgId)),
      switchMap(([action, orgId]) =>
        this.organizationService.updateOrganizationACOStatus(orgId, action.value).pipe(
          // isACO is already set optimistically by the isACOChanged reducer case above —
          // no success action needed, just surface failures.
          switchMap(() => EMPTY),
          catchError((error: HttpErrorResponse) =>
            of(OrganizationEMRDetailsActions.updateOrganizationACOStatusFailure({
              error: parseProblemDetailsError(error, 'Failed to update ACO status'),
            }))
          )
        )
      )
    );
  });

  constructor(
    private readonly actions$: Actions,
    private readonly store: Store,
    private readonly organizationService: OrganizationDetailsService,
  ) {}
}
